const en = {
  meta: {
    title: "AGUSTÍN GARCÍA",
    description: "I'm Agustín García, Frontend Developer",
  },
  nav: {
    home: "Home",
    portfolio: "Portfolio",
    about: "About",
    contact: "Contact",
    linkedin: "LinkedIn",
    github: "Github",
    copyright: "© {{year}} {{name}}",
  },
  home: {
    title: "I'm Agustín García",
    available: "Available for projects",
    animated: {
      first: "I love coding",
      second: "I build modern websites",
      third: "I develop React Native apps",
    },
    description:
      "Freelance FullStack Developer since 2020. Wordpress, PrestaShop, Shopify, and iOS/Android apps.",
    portfolioBtn: "My Portfolio",
    contactBtn: "Contact Me",
    scroll: "Scroll",
    highlightsTitle: "What I do",
    highlightsSubtitle:
      "Digital products for real clients: web, plugins, ecommerce, and mobile apps.",
    highlights: {
      wordpress: {
        title: "Wordpress & plugins",
        text: "Custom Elementor sites, SEO, bookings, and tailored plugins for AG Marketing clients.",
      },
      react: {
        title: "React & Frontend",
        text: "Modern interfaces, Gutenberg blocks, and fluid motion for product-ready UIs.",
      },
      apps: {
        title: "React Native apps",
        text: "PartFri and Guardify: Expo, APIs, Firebase, Laravel, and AI layers.",
      },
    },
    stats: {
      projects: "Projects shipped",
      years: "Years freelance",
      clients: "Real clients",
      offer: "Web, ecommerce & apps",
      offerValue: "Custom",
    },
    marqueeTitle: "Stack & tools",
    featuredTitle: "Featured work",
    featuredSubtitle: "AG Marketing products and high-impact client builds.",
    processTitle: "How I work",
    processSubtitle: "Clear process, constant communication, and quality delivery.",
    process: {
      discover: {
        title: "Discover",
        text: "I map the business, the user, and the product goals.",
      },
      design: {
        title: "Design",
        text: "We define UX, structure, and visual direction before building.",
      },
      build: {
        title: "Build",
        text: "Clean code, reusable components, and solid performance.",
      },
      launch: {
        title: "Launch",
        text: "Deploy, QA, final polish, and post-launch support.",
      },
    },
    seeWork: "See work",
    aboutCta: "About me",
    ctaBandTitle: "Ready to build something memorable?",
    ctaBandText: "Tell me your idea and let's turn it into a digital product.",
    folioLabel: "Folio / 2020 — Present",
    heroLine1: "FULL",
    heroLine2: "STACK",
    heroLine3: "DEVELOPER",
    featuredCount: "Featured projects ({{count}})",
    visitSite: "Visit site",
    talkMarquee: "LET'S TALK — LET'S COLLABORATE — SAY HELLO — WANNA START SOMETHING? — ",
    splitEyebrow: "since 2020",
    splitLeft: "FullStack",
    splitRight: "Developer",
    splitText:
      "I build websites, ecommerce, and apps: Wordpress, Shopify, PrestaShop, and React Native. Clean code, clear UX, and products that work day to day.",
    storyEyebrow: "How I work",
    storyTitle: "Web, ecommerce, and apps in production",
    story: {
      craft: {
        tag: "Web / Wordpress",
        heading: "Custom sites that load and convert",
        text: "Landings, corporate sites, and plugins for AG Marketing: Elementor, SEO, bookings, and clean code ready for real clients.",
      },
      product: {
        tag: "Ecommerce",
        heading: "Stores that sell without friction",
        text: "Shopify, PrestaShop, and Wordpress Woo: catalog, checkout, and performance built for leads and sales.",
      },
      apps: {
        tag: "Mobile apps",
        heading: "React Native in the real world",
        text: "PartFri and Guardify: real flows, APIs, Firebase, Laravel, and AI layers already in production.",
      },
    },
    casesEyebrow: "Selected cases",
    casesTitle: "Projects with impact",
    seeCase: "See case",
    scrollHint: "Scroll to explore",
    dragHint: "Scroll to move sideways",
    interestsTitle: "Stack & tools",
    interestsSubtitle: "What I use to ship products every week.",
    valuesTitle: "What sets me apart",
    valuesSubtitle: "Detail, speed, and real collaboration with clients.",
    values: {
      speed: {
        title: "Speed with judgment",
        text: "I ship fast without sacrificing quality or accessibility.",
      },
      craft: {
        title: "Usable product",
        text: "Clear flows, performance, and care in every delivery.",
      },
      collab: {
        title: "Clear collaboration",
        text: "Direct communication, frequent demos, and useful feedback.",
      },
    },
    testimonialsTitle: "Reviews",
    testimonialsSubtitle: "What clients and teams say about working with me.",
    testimonials: {
      one: {
        quote:
          "Agustín understands the business and turns ideas into clear, fast interfaces.",
        author: "Digital product client",
        role: "Product Owner",
      },
      two: {
        quote:
          "Clean delivery, strong communication, and attention to detail every sprint.",
        author: "Marketing team",
        role: "Project Lead",
      },
      three: {
        quote:
          "He shipped the site and booking plugin smoothly. Happy client, deadlines met.",
        author: "Lechuzas Properties",
        role: "Real estate client",
      },
      four: {
        quote:
          "On PartFri and Guardify he solved complex flows with APIs and solid React Native.",
        author: "AG Marketing",
        role: "Product / Apps",
      },
      five: {
        quote:
          "Custom Shopify and Wordpress, direct communication, and measurable sales results.",
        author: "Retail ecommerce",
        role: "Founder",
      },
    },
  },
  about: {
    pageTitle: "About me",
    aboutTitle: "Who I am",
    heroEyebrow: "FullStack · Freelance · 2020+",
    heroTitle: "Code, product, and real clients",
    aboutme:
      "Frontend Developer passionate about learning, taking on challenges, and building products that improve people's lives. I work across custom Wordpress sites, ecommerce, and React Native apps (AG Marketing), with a focus on performance, UX, and visual craft. Fun fact: I love playing guitar and football.",
    timeline: "Work experience",
    education: "Education",
    languages: "Languages",
    skills: "Skills",
    services: "Services",
    download: "CV",
    nowTitle: "Right now",
    nowText:
      "FullStack Developer freelance since 2020 (Wordpress, PrestaShop, Shopify, and apps). Also shipping AG Marketing products (Guardify / PartFri).",
    focusLabel: "Focus",
    focusWeb: "Web & plugins",
    focusShop: "Ecommerce",
    focusApps: "React Native apps",
    work: {
      freelance: {
        company: "Freelance",
        role: "FullStack Developer",
        date: "2020 — Present",
      },
      doowebs: {
        company: "Doowebs",
        role: "FullStack Developer",
        date: "Sep 2024",
      },
      anartxy: {
        company: "Anartxy",
        role: "Software Developer",
        date: "Jan 2023 — Aug 2023",
      },
      assembler: {
        company: "Assembler Institute of Technology",
        role: "Frontend Developer",
        date: "Feb 2022 — Nov 2022",
      },
      radoo: {
        company: "Radoo",
        role: "Project & Marketing Manager",
        date: "2020 — 2021",
      },
    },
    educationItems: {
      assembler: "Master in Software Development (1200h+, MERN & LAMP, Agile)",
      florida: "Leadership, Entrepreneurship and Innovation Degree",
      ceu: "Business Administration + Marketing (2 years)",
    },
    langLevels: {
      native: "Native",
      professional: "Professional",
      technical: "Technical",
    },
    langNames: {
      es: "Spanish",
      ca: "Catalan",
      en: "English",
      ko: "Korean",
    },
  },
  portfolio: {
    pageTitle: "Portfolio",
    subtitle:
      "Real projects from AG Marketing, freelance work, and personal products: websites, plugins, ecommerce, and apps.",
    viewProject: "View project",
    open: "Open",
    filterAll: "All",
    filterWeb: "Web",
    filterCode: "Code",
    filterShop: "Ecommerce",
    filterApp: "Apps",
    count: "{{count}} projects",
    blurbs: {
      partfri:
        "iOS/Android app to plan parties: guests, shared shopping, Spotify, and games.",
      guardify:
        "Healthcare shifts app with React Native, Laravel, Firebase, and AI (GuardifIA).",
      lechuzas:
        "Vacation/real-estate site with Elementor, multilingual setup, and custom bookings.",
      selectyourvet:
        "Veterinary platform with custom plugin, advanced search, and AI.",
      agmarketing:
        "AG Marketing website: design, SEO, custom plugins, and lead generation.",
      afterbite: "Corporate site focused on conversion and product clarity.",
      calculator: "Interactive UI with clean JS logic and instant feedback.",
      melody: "Full-stack music platform with auth, playlists, and API.",
      gif4u: "React + Firebase app to search and save GIFs.",
      pilatu: "Fitness site focused on branding and lead capture.",
      dermobal: "Clean, professional dermatology digital presence.",
      prolink: "Services website with tailored Wordpress architecture.",
      anartxy: "Ecommerce with Shopify, catalog, and brand experience.",
      spotify: "Spotify front clone with modern responsive UI.",
      fenix: "Events/stage site with a strong visual identity.",
      radoo:
        "Hospitality website (digital menus → delivery) built during COVID.",
      waqua: "Wordpress + Elementor site with integrations and modern UX.",
      triptomax: "Travel landing/site with CTA and basic SEO.",
      dentalcorbella:
        "Dental clinic: web design, marketing, and animations (AG Marketing).",
      valy: "Beauty ecommerce with catalog and brand experience.",
      v3nture:
        "V3B / V3nture Builders platform: custom plugin and web3 service search.",
      boconni: "Premium real estate with gallery and positioning.",
      lowgas:
        "React Native app for cheap gas stations: Ministry prices, Google routes, navigation, and CarPlay (AG Marketing).",
      tapiter:
        "Vite corporate site for a textiles manufacturer (upholstery, contract, fashion): brand, UX, and modern frontend.",
    },
    items: {
      partfri: "PartFri (iOS/Android App · AG Marketing)",
      guardify: "Guardify (React Native · Laravel · AI)",
      lowgas: "LowGas (React Native · Maps · AG Marketing)",
      tapiter: "Tapiter (Vite · Frontend)",
      lechuzas: "Lechuzas Properties (Wordpress · Bookings)",
      selectyourvet: "Select Your Vet (Plugin + AI)",
      agmarketing: "AG Marketing (Corporate website)",
      afterbite: "AfterBite (Wordpress)",
      calculator: "Calculator with Javascript",
      melody: "Melody Music Stream (React, NodeJS, MongoDB)",
      gif4u: "Gif 4 U (React, Firebase)",
      pilatu: "PilatuFitness (Wordpress)",
      dermobal: "Dermobal (Wordpress)",
      prolink: "Prolink (Wordpress)",
      anartxy: "Anartxy (Shopify)",
      spotify: "Spotify Clone Front (React)",
      fenix: "Fenix (Wordpress)",
      radoo: "Radoo (Wordpress · Hospitality)",
      waqua: "Waqua (Wordpress)",
      triptomax: "Triptomax (Wordpress)",
      dentalcorbella: "Dental Corbella (Wordpress · AG Marketing)",
      valy: "Valy Cosmetics (Wordpress)",
      v3nture: "V3B / V3nture Builders (Custom plugin)",
      boconni: "Boconni (Wordpress)",
    },
  },
  services: {
    agmarketing: {
      title: "Websites & plugins (AG Marketing)",
      description:
        "Wordpress/Elementor builds and custom products for real clients: SEO, plugins, maps, and modern frontends (Select Your Vet, Lechuzas, LowGas, Tapiter…).",
    },
    apps: {
      title: "iOS & Android apps",
      description:
        "Mobile products with React Native + Expo: PartFri, Guardify, and LowGas (maps, routes, and CarPlay).",
    },
    programming: {
      title: "Full stack & ecommerce",
      description:
        "1200h+ at Assembler (MERN/LAMP, Agile). Ecommerce with PrestaShop/Shopify and freelance projects with PHP, JS, Gutenberg, and custom themes/plugins.",
    },
  },
  contact: {
    pageTitle: "Contact",
    getInTouch: "Let's talk",
    eyebrow: "Available for projects",
    heroTitle: "Tell me what you want to build",
    email: "Email",
    phone: "Phone",
    description:
      "Have a project in mind? Drop me a message and let's talk about how I can help.",
    namePlaceholder: "Name",
    emailPlaceholder: "Email",
    messagePlaceholder: "Tell me about the project, timeline, and rough budget",
    sending: "Sending...",
    send: "Send message",
    success: "Message sent! Thank you for reaching out.",
    error: "Failed to send. Please try again.",
    response: "Usually reply within 24–48h",
  },
  lang: {
    es: "ES",
    en: "EN",
    label: "Language",
  },
};

export default en;
